import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const Phuluctable = React.memo(function Phuluctable(props) {
  const classes = useStyles();
  const { data } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>STT</th>
          <th className={classes.tablebc_th}>ĐƠN VỊ KIỂM ĐỊNH</th>
          <th className={classes.tablebc_th}>MÃ SỐ ĐƠN VỊ</th>
          <th className={classes.tablebc_th}>ĐỊA CHỈ</th>
          <th className={classes.tablebc_th}>
            SỐ DÂY CHUYỀN HOẠT ĐỘNG /TỔNG SỐ DÂY CHUYỀN
          </th>
          <th className={classes.tablebc_th}>
            SỐ ĐĂNG KIỂM VIÊN BẬC CAO/ TỔNG SỐ ĐĂNG KIỂM VIÊN
          </th>
          <th className={classes.tablebc_th}>NHÂN VIÊN NGHIỆP VỤ</th>
          <th className={classes.tablebc_th}>GHI CHÚ</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {data.map((row, i) => {
          if (row["stt"] !== 0) {
            return (
              <tr key={i}>
                <td className={classes.tablesotan_td}>{row["stt"]}</td>
                <td className={classes.tablesotan_td}>{row["ten"]}</td>
                <td className={classes.tablesotan_td}>{row["ma"]}</td>
                <td className={classes.tablesotan_td}>{row["diachi"]}</td>
                <td className={classes.tablesotan_td}>{row["daychuyen"]}</td>
                <td className={classes.tablesotan_td}>{row["dangkiemvien"]}</td>
                <td className={classes.tablesotan_td}>
                  {row["nhanviennghiepvu"]}
                </td>
                <td className={classes.tablesotan_td}></td>
              </tr>
            );
          } else {
            return (
              <tr key={i}>
                <td className={classes.tablesotan_td}></td>
                <td className={classes.tablesotan_td}></td>
                <td className={classes.tablesotan_td}></td>
                <td className={classes.tablesotan_td_bold}>{row["ten"]}</td>
                <td className={classes.tablesotan_td_bold}>
                  {row["daychuyen"]}
                </td>
                <td className={classes.tablesotan_td_bold}>
                  {row["dangkiemvien"]}
                </td>
                <td className={classes.tablesotan_td_bold}>
                  {row["nhanviennghiepvu"]}
                </td>
                <td className={classes.tablesotan_td}></td>
              </tr>
            );
          }
        })}
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div>
      <table className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

Phuluctable.propTypes = {
  data: PropTypes.array,
};
export default Phuluctable;
